import React from 'react';
import { Container,Row,Col,NavLink} from 'reactstrap';
import Careerslider from '../Career/Careerslider';
import SysFooter from '../Footer';
import backarrow from '../../images/back-arrow.svg';
function Jobdetails() {
  return (
    <div className="career-page">
   <Container fluid>
      
       <Careerslider/>
       
         <Row>
             <Col  md={{ size: 10, offset: 1 }}> <NavLink href="/Career" className="back-btn"><img src={backarrow}  alt="backarrow" />  <span className="back-btn-text">Back to see more jobs</span></NavLink></Col>
         </Row>
         <Row className="job-details">
         <Col  md={{ size: 10, offset: 1 }}>
            
             <h2 className="job-title-head">
                Senior AI Devops Engineer
             </h2>
             <div className="job-des">
             <h3>  Job description</h3>
             <h5>Responsibilities and Duties:</h5>
             <ul className="jobdes-list">
                 <li>Design, optimize, and manage the deployment of a Retrieval-Augmented Generation (RAG) architecture for a Large Language Model (LLM).</li>
                 <li>Design and implement infrastructure for developing and deploying RAG-based LLM solutions.</li>
                 <li>Optimize system performance, ensuring low-latency retrieval and response times.</li>
                 <li>Implement monitoring, logging, and observability solutions to diagnose and resolve performance bottlenecks.</li>
                 <li>Work closely with AI/ML teams to integrate infrastructure with retrieval mechanisms and vector databases.</li>
             </ul>
             <h3>  Job requirements</h3>
             <ul className="jobdes-list">
                 <li>Master’s degree or the foreign equivalent in Computer Science, or a closely related field</li>
                  <li>Published work relating to performance analysis in distributed systems.</li>
                  <li>Knowledge in statistical methodologies and applying these techniques to analyze and interpret real-world data.</li>
                  <li>Knowledge in distributed computing, caching strategies, and load balancing.</li>
                  <li>Experience with search engines such as Elasticsearch or OpenSearch.</li>
                  <li>Performance profiling, benchmarking, and observability.</li>
                  <li>Programming skills in Python, Go, or a similar language.</li>
                  <li>Job can be performed anywhere in the United States.</li>
            </ul>
            </div>
        </Col>
         </Row>
          <Row>
              <Col md={{ size: 8, offset: 2 }}> 
              <h2 className="text-center btm-text info"> If you think you fit in with the above requirements we d love to talk to you
                       about working in our organization.</h2>
              </Col>
          </Row>
           
   
   <Row className="getstarted-section">

<Col md={{ size: 8, offset: 2 }}>
      
        <h2 className="text-center p20 btm-text"> To apply for the job please mention the job title &</h2>
        <h2 className="text-center btm-text">send us your resume <span className="mail-info">Careers@systematrix.ai </span>
       
        </h2>
        <div className="m-20 text-center">
      
        </div>
    </Col>
</Row>
  







 <Row>
 <SysFooter/>
 </Row>
   </Container>
      

     </div>
    
    
  );
}

export default Jobdetails;
